// extracted by mini-css-extract-plugin
export default {"container":"jW-z","title":"kW-z","link":"lW-z"};